var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xxl-4"},[_c('MixedWidget1',{attrs:{"tingkat":"X"}})],1),_c('div',{staticClass:"col-xxl-4"},[_c('MixedWidget1',{attrs:{"tingkat":"XI"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }